export const styles = (theme, props) => ({
  label: {
    ...theme.palette.alternateText,
    fontSize: '10px',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    lineHeight: 1.5,
  },
  spaceBetween: {
    padding: '10px 20px',
    borderTop: 'solid rgba(0, 0, 0, 0.12) thin',
    display: 'flex',
    justifyContent: 'space-between',
    flexShrink: 0,
    backgroundColor: '#fff',
  },
  buttonsContainer: {
    padding: '10px 0 10px 10px',
  },
  button: {
    ...theme.palette.button,
    height: '100%',
    width: '128px',
  },
  placeholderContent: {
    minHeight: '200px',
    width: '100%',
  },
  modalContentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: props.showTemplateDropdown ? 'calc(100vh - 200px)' : 'auto',
    overflow: 'hidden',
  },
  templateListScrollContainer: {
    overflowY: 'scroll',
    flexGrow: 1,
    padding: '0 20px',
    backgroundColor: '#f9f9f9',
    borderTop: '1px solid #e0e0e0',
    boxShadow: 'inset 0 6px 6px -6px rgba(0,0,0,0.1)',
    minHeight: '1px',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f9f9f9',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#c1c1c1',
      borderRadius: '4px',
    },
  },
  formControlRow: {
    display: 'flex',
    alignItems: 'center',
  },
  boxFlex: {
    display: 'flex',
  },
  templateItem: {
    border: '1px solid #ccc',
    borderRadius: '8px',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    cursor: 'pointer',
    background: 'transparent',
    transition: 'background 0.2s, border 0.2s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  templateItemSelected: {
    border: '2px solid #1976d2',
    background: 'rgba(25, 118, 210, 0.08)',
  },
  templateListTitle: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
});
